"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var firebase = _interopRequireWildcard(require("firebase/app"));

var _models = require("@knxlab/models");

var _Centre = _interopRequireDefault(require("./Centre"));

var _Product = _interopRequireDefault(require("./Product"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var schema = {
  type: "object",
  properties: {
    productId: {
      type: "string"
    },
    qtyTriggerOrder: {
      type: "integer",
      min: 0
    },
    qtyMinInStock: {
      type: "integer",
      min: 0
    }
  },
  required: []
};
var NAME = "ProductCentreData";

var ProductCentreData = /*#__PURE__*/function (_AbstractObject) {
  _inherits(ProductCentreData, _AbstractObject);

  var _super = _createSuper(ProductCentreData);

  function ProductCentreData() {
    var _this;

    _classCallCheck(this, ProductCentreData);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "productId", void 0);

    _defineProperty(_assertThisInitialized(_this), "qtyTriggerOrder", void 0);

    _defineProperty(_assertThisInitialized(_this), "qtyMinInStock", void 0);

    _defineProperty(_assertThisInitialized(_this), "centreId", void 0);

    return _this;
  }

  _createClass(ProductCentreData, [{
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dbCollection, currentTime, data, productData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.productId) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Missing product id");

              case 2:
                this.validate();
                _context.next = 5;
                return _Centre["default"].getSubCollection({
                  centreId: this.centreId,
                  name: 'products'
                });

              case 5:
                dbCollection = _context.sent;
                currentTime = Math.floor(new Date().getTime() / 1000);
                data = this["export"]();

                if (!data.metadata) {
                  data.metadata = {};
                }

                _context.next = 11;
                return dbCollection.doc(this.productId).get();

              case 11:
                productData = _context.sent;
                data.metadata.updatedAt = currentTime;
                _context.next = 15;
                return dbCollection.doc(this.productId).set(data);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "getName",
    value: function getName() {
      return NAME;
    }
  }], [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
        var productId, centreId, dbCollection, productDoc, productData, productCentreData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                productId = _ref.productId, centreId = _ref.centreId;
                _context2.next = 3;
                return _Centre["default"].getSubCollection({
                  centreId: centreId,
                  name: 'products'
                });

              case 3:
                dbCollection = _context2.sent;
                _context2.next = 6;
                return dbCollection.doc(productId);

              case 6:
                productDoc = _context2.sent;
                _context2.next = 9;
                return productDoc.get();

              case 9:
                productData = _context2.sent;
                productCentreData = new ProductCentreData();
                productCentreData.productId = productId;
                productCentreData.centreId = centreId;

                if (productData.exists) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return", productCentreData);

              case 15:
                productCentreData.setData(productData.data());
                return _context2.abrupt("return", productCentreData);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getCollection",
    value: function getCollection() {
      throw new Error("getCollection is not supposed to be called for ProductCentreData");
    }
  }]);

  return ProductCentreData;
}(_models.AbstractObject);

exports["default"] = ProductCentreData;
ProductCentreData.register({
  name: NAME,
  schema: schema,
  __class: ProductCentreData
});